"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    arenas: function() {
        return arenas;
    },
    defaultArenaConfig: function() {
        return defaultArenaConfig;
    }
});
const defaultArenaConfig = {
    // rope
    ropeWidth: 6,
    ropeColor: "#201e3b",
    // table
    table: true,
    tableBorderWidth: 4,
    tableLength: 80,
    tableDepth: 40,
    // mat
    matDirection: "vertical",
    matBorderWidth: 4,
    matLength: 40,
    matDepth: 80,
    matBorderColor: "#474156",
    matColorOne: "#443d4f",
    matTwoColor: "#3e3746",
    // turnbuckle
    turnbuckleSize: 10,
    turnbuckleColor: "#000",
    // ring
    ringCenterColor: "#b6a6b3",
    ringRadiusColor: "#a795bb",
    // misc
    image: ""
};
const arenas = [
    // aew
    {
        ...defaultArenaConfig,
        ropeColor: "#201e3b",
        turnbuckleColor: "#000",
        ringCenterColor: "#b6a6b3",
        ringRadiusColor: "#a795bb",
        matBorderColor: "#474156",
        matColorOne: "#443d4f",
        matTwoColor: "#3e3746",
        matDirection: "horizontal",
        showId: "dynamite",
        table: false
    },
    // smackdown
    {
        ...defaultArenaConfig,
        ropeColor: "#fff",
        turnbuckleColor: "#3b2ffe",
        ringCenterColor: "#aab9c0",
        ringRadiusColor: "#d2e4f8",
        matBorderColor: "#444",
        matColorOne: "#333",
        matTwoColor: "#000",
        tableColor: "#000",
        tableBorderColor: "#999",
        tableDirection: "left",
        table: true,
        showId: "smackdown",
        image: "https://www.wwe.com/f/styles/wwe_show_logo_l/public/all/2019/10/SmackDown_2019_Vert_White--dfb28435b27ecf12e75406176c168c6a.png"
    },
    // raw
    {
        ...defaultArenaConfig,
        ropeColor: "#fff",
        turnbuckleColor: "#df3b3f",
        ringCenterColor: "#d7e6f3",
        ringRadiusColor: "#516283",
        matBorderColor: "#444",
        matColorOne: "#333",
        matTwoColor: "#000",
        tableColor: "#000",
        tableBorderColor: "#999",
        tableDirection: "left",
        table: true,
        showId: "raw",
        image: "https://www.wwe.com/f/styles/wwe_show_logo_l/public/all/2022/06/RAW-Logo--7d5dc4d69611241d54973979bdae1d32.png"
    },
    // nxt2
    {
        ...defaultArenaConfig,
        ropeColor: "#fff",
        turnbuckleColor: "#fff",
        ringCenterColor: "#afa5a9",
        ringRadiusColor: "#cbc7ca",
        matBorderColor: "#222",
        matColorOne: "#534e50",
        matTwoColor: "#363130",
        table: false,
        showId: "nxt",
        image: "https://www.wwe.com/f/styles/wwe_show_logo_sm/public/all/2022/09/NXT_NewLogo--61a7c04575fabf96fb577dcdfc0bde63.png"
    },
    // retro
    {
        ...defaultArenaConfig,
        ropeColor: "#eeaf30",
        turnbuckleColor: "#1b55a1",
        tableColor: "#0c0f75",
        tableBorderColor: "#000",
        ringCenterColor: "#8badf3",
        ringRadiusColor: "#516283",
        matBorderColor: "#0c0f75",
        matColorOne: "#3485bb",
        matTwoColor: "#4b86c4",
        tableDirection: "top",
        showId: "snme",
        image: "//www.wwe.com/f/styles/wwe_show_logo_sm/public/all/2019/03/HallOfFame_2019--2abc07334db4d339fbf4fd06f740fe53.png"
    },
    // gym hall
    {
        ...defaultArenaConfig,
        ropeColor: "#000",
        turnbuckleColor: "#80202b",
        tableColor: "#999",
        tableBorderColor: "#7c6a60",
        ringCenterColor: "#b3aab5",
        ringRadiusColor: "#c7bccc",
        matBorderWidth: 0,
        matColorOne: "#969692",
        matTwoColor: "#969692",
        table: false
    }
] // nxt
 // {
 //     ...defaultArenaConfig,
 //     ropeColor: '#eeaf30',
 //     turnbuckleColor: '#000',
 //     ringCenterColor: '#000',
 //     ringRadiusColor: '#655e65',
 //     matBorderColor: '#444',
 //     matColorOne: '#000',
 //     matTwoColor: '#222',
 //     table: false
 // },
;
